import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FlexLayoutModule } from '@angular/flex-layout';
// import { AdalService, AdalInterceptor, AdalGuard } from 'adal-angular4';
// import { MsAdalAngular6Module, MsAdalAngular6Service, AuthenticationGuard } from 'microsoft-adal-angular6';
import { MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { Logger } from 'msal';
import { PermissionGuard } from './core/guard/permission.guard';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardFilterComponent } from './shared/components/dashboard-filter/dashboard-filter.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from './core/adal/auth-token-interceptor';
import { ToastrModule } from 'ngx-toastr';
import { LineDashboardModule } from './features/line-dashboard/line-dashboard.module';
import { WasteInfoComponent } from './shared/components/waste-info/waste-info.component';
import { FactoryPopupComponent } from './features/search/components/top-worst/factory-popup/factory-popup.component';
import { CategoryPopupComponent } from './features/search/components/top-worst/category-popup/category-popup.component';
import { SelectCaivanoLineComponent } from './features/caivano-dashboard/components/select-caivano-line/select-caivano-line.component';
import { TimeLossPopupComponent } from './features/caivano-dashboard/components/time-loss-popup/time-loss-popup.component';
import {
    CausalResultantPopupComponent
} from './features/caivano-dashboard/components/causal-resultant-popup/causal-resultant-popup.component';
import {
    ManualEntryPopupComponent
} from './features/caivano-dashboard/components/manual-entry-popup/manual-entry-popup.component';
import { MapSelecionPopupComponent } from './features/spare-capacity/components/map-selecion-popup/map-selecion-popup.component';
import { SelectLineComponent } from './shared/components/select-line/select-line.component';
import { EnvironmentService } from './core/services/environment.service';
import { environment, protectedResourceMap } from 'src/environments/environment';
import { from } from 'rxjs';
import { DataAnalyticsModule } from './features/data-analytics/data-analytics.module';
import { SaveTagPopupComponent } from './features/data-analytics/components/save-tag-popup/save-tag-popup.component';
import { Usagereport } from './shared/handlers/usagereport';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { AuthGuardService } from './core/services/can-activate.guard.service';
import { IdleTimeoutService } from './core/services/idle-timeout.service';

export function loggerCallback(message) {
    // console.log('client logging' + message);
}
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
registerLocaleData(en);
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        HammerModule,
        BrowserModule,
        AppRoutingModule,
        // BrowserAnimationsModule,
        FlexLayoutModule,
        CoreModule,
        SharedModule,
        HttpClientModule,
        DataAnalyticsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ToastrModule.forRoot(),
        NoopAnimationsModule,
        FormsModule,
        LineDashboardModule,
        MatInputModule,
        MatButtonModule,
        MatFormFieldModule,
        MatDialogModule,
        MatIconModule,
        MatTooltipModule,
        NgxPermissionsModule.forRoot(),
        PopoverModule.forRoot(),
        MsalModule.forRoot({
            auth: environment.msalAuthConfig.auth,
            cache: {
                cacheLocation: 'sessionStorage',
                storeAuthStateInCookie: isIE, // set to true for IE 11
            },
            framework: {
                unprotectedResources: ['https://www.microsoft.com/en-us/'],
                protectedResourceMap: new Map(protectedResourceMap)
            },
            system: {
                loadFrameTimeout: 30000,
                // logger: new Logger(loggerCallback, {
                //   correlationId: '1234',
                //   piiLoggingEnabled: true
                // })
            }
        }, {
            popUp: false,
            consentScopes: [
                'user.read',
                'openid',
                'profile',
            ],
            extraQueryParameters: {}
        }),
    ],
    providers: [
        IdleTimeoutService,
        // AdalService, AdalGuard,
        Usagereport,
        AuthGuardService, PermissionGuard, NgxPermissionsService,
        // { provide: 'adalConfig', useFactory: msAdalAngular6ConfigFactory, deps: [] },
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

// let adalConfig: any;

// export function msAdalAngular6ConfigFactory() {
//     return adalConfig; // will be invoked later when creating MsAdalAngular6Service
// }

// export function initializeApp(envSer: EnvironmentService) {
//     adalConfig = {
//         tenant: envSer.getTenantID(),
//         clientId: envSer.getClientID(),
//         cacheLocation: envSer.getCacheLocation(),
//         redirectUri: envSer.getRedirectURI(),
//         navigateToLoginRequestUrl: false,
//         endpoints: envSer.getEndPoint()
//     };
// }
